export interface PaymentMethod {
  id: string;
  type: PaymentMethodType;
  brand?: string; // e.g., 'visa', 'mastercard'
  last4?: string;
  expMonth?: number;
  expYear?: number;
  isDefault: boolean;
  // Add other potential fields if needed based on Stripe object structure
}

export enum PaymentMethodType {
  Card = 'card',
  BankTransfer = 'bank_transfer',
}
